import { TitleCasePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { ClientFortressType } from '../../core';

interface ItemType {
  class: string;
  label: string;
}

@Component({
  selector: 'app-fortress-type-label',
  imports: [TitleCasePipe],
  templateUrl: './fortress-type-label.component.html',
  styleUrl: './fortress-type-label.component.scss',
})
export class FortressTypeLabelComponent {
  type = input<ClientFortressType | null>();
  parsedType = computed(
    () =>
      ({
        label: this.type() === 'PERMISSION_OBJECT' ? 'Permission Object' : this.type()?.toLowerCase(),
        class: this.type()?.toLowerCase(),
      }) as ItemType,
  );
}
